import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { MinusSmallIcon, PlusSmallIcon } from "@heroicons/react/24/outline";

const faqs = [
  {
    question: "Hoe kan ik een offerte aanvragen?",
    answer:
      "Goed nieuws! Met onze handige offertemodule vraagt u een offerte aan in slechts enkele minuten.",
  },
  {
    question: "Welke gegevens heb ik nodig om een offerte aan te vragen?",
    answer:
      "Alle nodige gegevens worden in onze offertemodule opgevraagd. Wanneer er iets ontbreekt, neemt ons team contact met u op.",
  },
  {
    question:
      "Ik ben reeds verzekerd, kan ik nog steeds een offerte aanvragen?",
    answer:
      "Natuurlijk! Wij bij boot-verzekering.be doen steeds ons uiterste best om uw vaartuig zo optimaal mogelijk te verzekeren. Vervolgens vergelijken wij uw bestaande contract met de nieuwe offertes.",
  },
  {
    question:
      "Ik ben reeds verzekerd maar ik wil mijn contract opzeggen en een nieuw contract afsluiten via boot-verzekering.be, hoe werkt dit?",
    answer:
      "Goede keuze! Samen met jou bekijken wij wanneer we het oude contract kunnen opzeggen. Wij ondersteunen u volledig in deze procedure.",
  },
  {
    question: "Waarom heb ik een bootverzekering nodig?",
    answer:
      "Een bootverzekering biedt financiële bescherming tegen schade, diefstal en aansprakelijkheid, afhankelijk van de gekozen dekking, zodat u met een gerust hart het water op kunt.",
  },
  {
    question: "Welke bootverzekeringen bieden jullie aan?",
    answer:
      "Burgerlijke aansprakelijkheid, bescherming en verlies, lichtingskosten, rechtsbijstand en persoonlijke ongevallen.",
  },
  {
    question: "Wat dekt een bootverzekering precies?",
    answer:
      "Wat uw verzekeringscontract precies dekt, is afhankelijk van de gekozen waarborgen.",
  },
  {
    question: "Is schade door storm of blikseminslag gedekt?",
    answer:
      "Ja, schade door natuurkrachten zoals storm of blikseminslag is doorgaans verzekerd binnen de dekking voor materiële schade aan het vaartuig.",
  },
  {
    question: "Is een bootverzekering verplicht?",
    answer:
      "In België is er geen verplichting om een burgerlijke aansprakelijkheidsverzekering af te sluiten voor je vaartuig. Andere instanties kunnen dit echter wel vereisen, denk bijvoorbeeld aan een jachthaven, of om lid te worden van een watersportvereniging. Daarnaast is er in andere landen wel een verzekeringsplicht. U loopt ook het risico om persoonlijk aansprakelijk gesteld te worden voor schade die wordt toegebracht aan derden, als u niet verzekerd bent.",
  },
  {
    question: "Zijn opvarenden verzekerd bij een ongeval?",
    answer:
      "Ja, met de dekking ‘persoonlijke ongevallen’ zijn opvarenden verzekerd bij lichamelijke schade door een ongeval met de boot. Afhankelijk van de gekozen waarborgen is er dekking voorzien.",
  },
  {
    question: "Zijn waterskiërs ook verzekerd?",
    answer:
      "Schade aan derden door waterskiërs kan verzekerd worden in de burgerlijke aansprakelijkheid van het vaartuig indien dit specifiek in de bijzondere voorwaarden wordt vermeld. Indien je ook de waarborg ‘persoonlijke ongevallen’ hebt onderschreven, worden ongevallen als waterskiër ook gedekt conform de voorwaarden van het afgesloten contract.",
  },
  {
    question: "Heb je vragen bij het afsluiten van je verzekering?",
    answer: "Neem gerust contact met ons op, wij helpen u graag verder.",
  },
  {
    question: "Hoe wordt de verzekeringspremie bepaald?",
    answer:
      "Dit is afhankelijk van het type vaartuig, bouwjaar, ligplaats, waarde, leeftijd en gebruik.",
  },
  {
    question: "Hoe meld ik schade?",
    answer:
      "Stuur ons een mailtje of neem contact met ons op. Wij begeleiden u met de afhandeling van de schade.",
  },
  {
    question: "Kan ik mijn boot ook verzekeren voor gebruik in het buitenland?",
    answer:
      "Ja, dat is mogelijk, op voorwaarde dat u gedomiciliëerd bent in België.",
  },
  {
    question: "Voor welke vaargebieden kan ik mijn boot verzekeren?",
    answer:
      "U kan uw vaartuig verzekeren voor de onderstaande zones:\n" +
      "• ZONE 1 : alle wateren en zeeën van de Benelux, Duitsland, Frankrijk, het Verenigd Koninkrijk en Republiek Ierland, ten noorden van 47° NB en ten zuiden van 54° NB en ten Oosten van 7° WL.\n" +
      "• ZONE 2 : zone 1 + alle wateren en zeeën van de landen van geografisch Europa en in die gelegen aan de Middellandse Zee, Noordzee, Kanaal, Atlantische Oceaan, Oostzee, Tyrreense Zee, Egeïsche Zee, Adriatische Zee en Ionische Zee, met uitzondering van de territoriale wateren van het Midden-Oosten. Europese Atlantische kustlijn is verzekerd tot 100 nautische mijl van de kust (daarin begrepen de bijbehorende eilanden, alsook op de Azoren, de Canarische Eilanden, Madeira en IJsland).",
  },
  {
    question: "Mag mijn ankerplaats in het buitenland liggen?",
    answer:
      "Ja, zolang de ankerplaats gelegen is in België of in de Europese Unie.",
  },
  {
    question:
      "Mag de inschrijving van mijn vaartuig anders zijn dan een Belgische inschrijving?",
    answer:
      "Ja, zolang de inschrijving is gebeurd in een land van de Europese Unie.",
  },
  {
    question: "Hoe betaal ik mijn verzekeringspremie?",
    answer: "Dit doet u per overschrijving of via domiciliëringsopdracht.",
  },
  {
    question: "Is mijn trailer ook verzekerd?",
    answer: "Dit is afhankelijk van het contract dat u hebt afgesloten.",
  },
  {
    question: "Wat als ik mijn vaartuig verkoop?",
    answer:
      "Als u uw boot verkoopt, kunt u uw verzekering stopzetten of overzetten naar een nieuwe boot. Neem contact met ons op voor de beste oplossing.",
  },
];

export default function FAQ() {
  return (
    <div>
      <section>
        <div className="mx-auto max-w-7xl px-6 py-10 sm:py-16 lg:px-8 lg:py-5">
          <div className="mx-auto max-w-4xl">
            <h2 className="text-4xl font-semibold tracking-tight text-[#1a2a6c] sm:text-5xl">
              Veelgestelde <span className="text-[#ff6f61]">vragen</span>
            </h2>
            <h4 className="text-xl tracking-tight text-[#1a2a6c] sm:text-2xl mt-4">
              Op onze FAQ vind je misschien een antwoord op je vraag. Zo niet
              staat ons team klaar om je vragen te beantwoorden. Bezorg ze aan
              ons via onze{" "}
              <a
                href="/contact"
                className="text-[#ff6f61] underline hover:text-[#ff8b7c]"
              >
                contactpagina
              </a>
              .
            </h4>
            {/* Left-aligned short blue line */}
            <hr className="mt-6 mb-10 border-t-2 border-[#1a2a6c] w-2/5" />
            <dl className="mt-10 space-y-6 divide-y divide-gray-900/10">
              {faqs.map((faq) => (
                <Disclosure key={faq.question} as="div" className="pt-6">
                  <dt>
                    <DisclosureButton className="group flex w-full items-start justify-between text-left text-[#ff6f61] bg-transparent rounded-md px-3 py-2 hover:bg-[#1a2a6c] hover:text-white transition-all duration-200 ease-in-out">
                      <span className="text-base font-semibold leading-7">
                        {faq.question}
                      </span>
                      <span className="ml-6 flex h-7 items-center">
                        <PlusSmallIcon
                          aria-hidden="true"
                          className="h-6 w-6 group-data-[open]:hidden"
                        />
                        <MinusSmallIcon
                          aria-hidden="true"
                          className="h-6 w-6 [.group:not([data-open])_&]:hidden"
                        />
                      </span>
                    </DisclosureButton>
                  </dt>
                  <DisclosurePanel as="dd" className="mt-2 pl-3 pr-3">
                    <p className="text-base leading-7 text-[#1a2a6c]">
                      {faq.answer}
                    </p>
                  </DisclosurePanel>
                </Disclosure>
              ))}
            </dl>
          </div>
        </div>
      </section>

      <section>
        <div className="mx-auto max-w-7xl px-6 py-16 sm:py-16 lg:px-8 lg:py-16">
          <h2 className="text-3xl font-semibold tracking-tight text-[#1a2a6c] sm:text-4xl">
            Bij <span className="underline">boot-verzekering.be</span> helpen
            wij jou navigeren naar{" "}
            <span className="text-[#ff6f61]">de beste verzekering</span> voor
            jouw vaartuig. Vraag nu jouw{" "}
            <span className="text-[#ff6f61]">offerte</span> aan!
          </h2>
          <div className="mt-10 flex items-center gap-x-6">
            <a
              href="#"
              className="rounded-md bg-[#1a2a6c] px-5 py-3 text-base font-bold text-[#ff6f61] shadow-lg hover:bg-[#142057] hover:shadow-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1a2a6c]"
            >
              Ja, ik wil mijn vaartuig verzekeren
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
